import React, { useEffect, useState } from 'react'
import PageHeading from '../../components/PageHeading'

// Master APIs
import GetDepartmentMaster from '../../APIs/Master/DepartmentMaster/GetDepartmentMaster'
import GetDesignationMaster from '../../APIs/Master/DesignationMaster/GetDesignationMaster'
import GetRoleMaster from '../../APIs/Master/RoleMaster/GetRoleMaster'
import GetUserType from '../../APIs/Master/UserTypeMaster/UserTypeMaster'
import SignUpApi from '../../APIs/SignUp/SignUpApi'
import GetUsers from '../../APIs/User/GetUsers'
import GetAllClientId from '../../APIs/Master/ClientMaster/Getallclients'
import InsertClientdata from '../../APIs/Master/ClientMaster/InsertClientdata'

export const ClientMaster = () => {
    const clientId = window.clientId;
    const [roleList, setRoleList] = useState([])
    const [userTypeList, setUserTypeList] = useState([])
    const [designationList, setDesignationList] = useState([])
    const [departmentList, setDepartmentList] = useState([])
    const [userList, setuserList] = useState([])

    const [sendForm, setSendForm] = useState({
        name: "",
        mobileNo: "",
        userId: window.userId,
        clientId: window.userId,
        handlingby: ""
    })

    const handleChange = (e) => {

        const { name, value, type, checked } = e.target
        // Allow only numbers in mobile number field
        let updatedvalue = value
        if (name === "mobileNo") {
            updatedvalue = updatedvalue.replace(/\D/g, "");
        }
        setSendForm(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked : updatedvalue
        }))
    }
    const handleSave = async () => {

        const name = sendForm.name?.trim();
        const phoneNumber = sendForm.mobileNo?.trim();
        const handlingby = sendForm.handlingby?.trim();

        // Required Validation
        if (!name || !phoneNumber || !handlingby) {
            alert('Fill all required fields');
            return;
        }

        // Mobile Length Validation
        if (phoneNumber.length !== 12) {
            alert('Mobile number must be exactly 12 digits');
            return;
        }

        try {

            const response = await InsertClientdata(
                clientId,
                name,
                phoneNumber,
                handlingby
            );

            if (response?.status === 1) {

                alert('Client added successfully');
                handleClear();

            } else {

                alert(response?.message || 'Failed to save data');
            }

        } catch (error) {

            console.log(error);
            alert('Something went wrong');
        }
    }
    // const handleSave = async () => {

    //     const name = sendForm.name;
    //     const phoneNumber = sendForm.mobileNo;
    //     const handlingby = sendForm.handlingby;
    //     // console.log("User Save Payload :", payload)
    //     if (name !== "" && phoneNumber !== "" && handlingby !== "") {
    //         const response = await InsertClientdata(clientId, name, phoneNumber, handlingby);
    //         if (response.status === 1) {
    //             alert('Client added successfully')
    //             // getclientdata()
    //             handleClear();

    //         }
    //         else {
    //             alert(response.responseValue);
    //         }
    //     }
    //     else {
    //         alert('Fill the required fields')
    //     }

    //     // await SaveUser(payload)
    // }
    const getclientdata = async () => {
        let data = await GetAllClientId(clientId);
        setuserList(data?.message)
    }
    useEffect(() => {
        // getclientdata()
    }, [])
    const handleClear = () => {
        setSendForm({
            name: "",
            mobileNo: "",
            handlingby: ""
        }
        )
    }
    return (
        <div className='row'>
            <PageHeading pagename="Client Master" />

            <div className='row container-fluid landformconatiner p-4'>

                {/* Name */}
                <div className='col-md-4 mb-3'>
                    <label className='form-label'>Name*</label> <br />
                    <input
                        className='form-input-box'
                        name="name"
                        value={sendForm.name}
                        onChange={handleChange}
                        style={{ width: '100%' }}
                        placeholder='Client Name'
                        required
                    />
                </div>
                {/* Mobile */}
                <div className='col-md-4 mb-3'>
                    <label className='form-label'>Mobile No*</label><br />
                    <input
                        className='form-input-box'
                        name="mobileNo"
                        value={sendForm.mobileNo}
                        onChange={handleChange}
                        style={{ width: '100%' }}
                        placeholder='Phone Number Eg-916382817288'
                        required
                        maxLength={12}
                        minLength={12}
                    />
                </div>
                <div className='col-md-4 mb-3'>
                    <label className='form-label'>Handling By*</label> <br />
                    <input
                        className='form-input-box'
                        name="handlingby"
                        value={sendForm.handlingby}
                        onChange={handleChange}
                        style={{ width: '100%' }}
                        placeholder='Handling By'
                        required
                    />
                </div>
                {/* Save */}
                <div className='col-12 mt-3'>
                    <button className='btn btn-primary' onClick={handleSave}>
                        Save
                    </button>
                </div>

            </div>
            {/* <div className="pt-4">
                <table className="table">
                    <thead>
                        <tr className="table-head">

                            <th>Sno.</th>
                            <th>Name</th>
                            <th>Phone Number</th>
                        </tr>
                    </thead>
                    <tbody style={{ width: "100%" }}>
                        {userList && userList.map((val, ind) => {
                            return (
                                <tr>
                                    <td>
                                        {ind + 1}
                                    </td>
                                    <td>
                                        {val.name}
                                    </td>
                                    <td>
                                        {val.phoneNumber}
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div> */}
        </div>
    )
}
